import type { TFunction } from "i18next";
import { hourMs } from "verdi-common/timeConstants";
import { EVENT_MAX_FUTURE_START_MS } from "../on-demand-irrigation-constants";
import { BASE_UNIT_VALUE } from "./form-constants";

export type StartToggleValue = "now" | number;

export type ResolveStartMsParams = {
    nowMs: number;
    customInput: string;
    clockStartMs: number | null;
    toggle: StartToggleValue | null;
    presetSnapMs: number;
};

/** Resolves the selected start instant from presets, typed minutes, or a clock pick. Null means start now. */
export function resolveStartMs({
    nowMs,
    customInput,
    clockStartMs,
    toggle,
    presetSnapMs,
}: ResolveStartMsParams): number | null {
    if (customInput !== "" || clockStartMs !== null) {
        if (clockStartMs !== null) return clockStartMs;

        const minutes = Number(customInput);
        if (Number.isFinite(minutes) && minutes > 0) {
            return nowMs + minutes * BASE_UNIT_VALUE;
        }

        return null;
    }

    if (toggle === "now" || toggle === null) return null;
    return presetSnapMs + toggle;
}

/** Validates a resolved start delay from now. Typed minutes are checked before delay bounds. */
export function validateStartDelay(
    t: TFunction,
    nowMs: number,
    startMs: number | null,
    customInput: string,
): string | null {
    if (customInput !== "") {
        const minutes = Number(customInput);
        if (!Number.isFinite(minutes)) return t("start-delay-not-numeric");
        if (minutes <= 0) return t("start-delay-must-be-positive");
    }

    if (startMs === null) return null;

    const delayMs = startMs - nowMs;
    if (delayMs > EVENT_MAX_FUTURE_START_MS) {
        return t("start-delay-too-far", { maxDelayHours: EVENT_MAX_FUTURE_START_MS / hourMs });
    }

    return null;
}
